import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRouteConstants } from '../../../core/constants/api-routes';
import { Observable } from 'rxjs';
import { CoordinateIsInUSOrTerritoriesRequest } from './models/coordinate-is-in-us-or-territories-request';
import { ValidationResult } from './models/validation-result';

@Injectable({
    providedIn: 'root',
})
export class ValidationService {
    private readonly applicationApiRoute = ApiRouteConstants.Validation;

    constructor(private readonly http: HttpClient) {}

    coordinateIsInUSOrTerritories(
        request: CoordinateIsInUSOrTerritoriesRequest,
    ): Observable<ValidationResult> {
        return this.http.post<ValidationResult>(
            this.applicationApiRoute.coordinateIsInUSOrTerritories,
            request,
        );
    }
}
